import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ImportEstimation/components/DifficultConditions/ConditionLayout.tsx";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { IconButton, Trash, Tooltip, Button } from '@gmini/ui-kit';
import { CloseButtonWrap, Container, Content, FirstLine, WarningDeleteText, Popover, WarningActions, WarningContainer } from "./ConditionLayout.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ConditionLayout = /*#__PURE__*/React.memo(function (_ref) {
  var formulaInput = _ref.formulaInput,
      onRemove = _ref.onRemove,
      header = _ref.header,
      disabled = _ref.disabled,
      noteText = _ref.noteText;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handleClick = React.useCallback(function (event) {
    setAnchorEl(event.currentTarget);
  }, []);
  var handleClose = React.useCallback(function () {
    setAnchorEl(null);
  }, []);
  var handleConfirmRemove = React.useCallback(function () {
    handleClose();
    onRemove === null || onRemove === void 0 ? void 0 : onRemove();
  }, [handleClose, onRemove]);
  var open = Boolean(anchorEl);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(FirstLine, {
        children: header
      }), formulaInput, noteText]
    }), /*#__PURE__*/_jsx("div", {
      children: onRemove && /*#__PURE__*/_jsxs(CloseButtonWrap, {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0432\u044B\u0447\u0438\u0441\u043B\u0438\u043C\u0443\u044E \u043A\u043E\u043B\u043E\u043D\u043A\u0443",
          children: /*#__PURE__*/_jsx(IconButton, {
            "data-test-id": "removeCalculationColumn",
            type: "circle",
            onClick: handleClick,
            disabled: disabled,
            children: /*#__PURE__*/_jsx(Trash, {
              color: "rgba(53, 59, 96, 0.25)"
            })
          })
        }), /*#__PURE__*/_jsx(Popover, {
          open: open,
          anchorEl: anchorEl,
          onClose: handleClose,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center'
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'center'
          },
          children: /*#__PURE__*/_jsxs(WarningContainer, {
            children: [/*#__PURE__*/_jsx(WarningDeleteText, {
              children: "\u0412\u044B \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043A\u043E\u043B\u043E\u043D\u043A\u0443?"
            }), /*#__PURE__*/_jsxs(WarningActions, {
              children: [/*#__PURE__*/_jsx(Button, {
                color: "warning",
                disabled: disabled,
                onClick: handleConfirmRemove,
                "data-test-id": "acceptToRemoveCalculationColumn",
                children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C"
              }), /*#__PURE__*/_jsx(Button, {
                color: "secondary",
                onClick: handleClose,
                "data-test-id": "declineToRemoveCalculationColumn",
                children: "\u041E\u0442\u043C\u0435\u043D\u0430"
              })]
            })]
          })
        })]
      })
    })]
  });
});
ConditionLayout.displayName = 'ConditionLayout';